import { SearchListItem } from '@finance-lab/utils/types'

export const getUrlForType = (option: Pick<SearchListItem, 'entityType' | 'id'> & { originIssueId?: string }) => {
    if (option.entityType === 'Issue') {
        return `/issues/${option.originIssueId ?? option.id}`
    } else if (option.entityType === 'Warrant') {
        return `/warrants/${option.id}`
    } else if (option.entityType === 'Company') {
        return `/companies/${option.id}`
    } else if (option.entityType === 'Investor') {
        return `/investors/${option.id}`
    } else if (option.entityType === 'Convertible') {
        return `/convertibles/${option.id}`
    }
}
